<template>
    <b-modal v-model="showModal" size="xl" @hidden="cancelar" @close="cancelar" button-size="md" hide-footer
        :title="prefix + title">
        <b-card bg-variant="light">
            <div class="d-flex align-items-center justify-content-center">
                <strong>{{ departamento.descricao }}</strong>
            </div>
        </b-card>
        <div class="d-flex justify-content-end align-items-end class mb-3">
            <b-button :id="'novoConfiguracaoAlmoxarifadoUnidade'" @click="showModalSelecionarAlmoxarifado()" size="sm">
                <b-icon icon="plus" />
                <b-tooltip :target="'novoConfiguracaoAlmoxarifadoUnidade'" title="Adicionar novo..."></b-tooltip>

            </b-button>
        </div>

        <b-card bg-variant="light">
            <b-table responsive class="mt-2" small :busy="this.busy" :items="this.almoxarifados"
                :fields="this.tableFields" :hover="true" show-empty>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>

                <template #empty>
                    <p>
                        Nenhum Registro encontrado
                    </p>
                </template>

                <template v-slot:cell(classificacao)="row">
                    {{ row.item.principal == 1 ? 'Central' : 'Secundário' }}
                </template>

                <template v-slot:cell(situacao)="row">
                    <div :id="row.index + 'switchGrupo'">
                        <b-form-checkbox v-model="row.item.situacao" @change="alteraSituacao(row.item)"
                            name="check-button" switch size="lg" :value="1" :unchecked-value="0" />
                        <b-tooltip :target="row.index + 'switchGrupo'" title="Ativar/Desativar..."></b-tooltip>
                    </div>
                </template>
                <template #cell(favorito)="row">
                    <b-button :id="row.index + 'favorito'" v-if="row.item.principal == 0"
                        @click="mudarFavorito(row.item)" size="sm">
                        <b-icon icon="star" />
                    </b-button>
                    <b-tooltip :target="row.index + 'favorito'" title="Tornar principal"></b-tooltip>

                </template>


                <template #cell(remover)="row">
                    <b-button :id="row.index + 'remover'" @click="remover(row.item)" size="sm">
                        <b-icon icon="trash" />
                        <b-tooltip :target="row.index + 'remover'" title="Remover"></b-tooltip>

                    </b-button>
                </template>

            </b-table>
        </b-card>
        <LgFinderPageAlmoxarifadoModal v-if="modalSelecionarAlmoxarifado" @close="fecharModalSelecionarAlmoxarifado"
            @onSelect="selecionarAlmoxarifado" :prefix="prefix + title + ' > '"></LgFinderPageAlmoxarifadoModal>
    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource";
import { FormResourceMixin } from "@/core/mixins/resource";

import LgFinderPageAlmoxarifadoModal from "@/components/Modal/LgFinderPageAlmoxarifadoModal.vue";

export default {
    components: {
        LgFinderPageAlmoxarifadoModal
    },
    props: {
        departamento: {
            type: Object,
            default: null,
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Configuração Almoxarifado",
        },
        currentSubgrupo: Object,
    },
    computed: {
        tableFields() {
            return [
                {
                    key: "classificacao",
                    label: "Classificação",
                    thStyle: "font-size: 10px; font-weight: 400;",
                    tdStyle: "font-size: 10px",
                },
                {
                    key: "almoxarifado",
                    label: "Descrição",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "situacao",
                    label: " ",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "favorito",
                    label: " ",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "remover",
                    label: " ",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
            ]
        },
    },

    data() {
        return {
            modalSelecionarAlmoxarifado: false,
            almoxarifados: [],
            showModal: true,
            form: {
                classe: {},
            },
        }
    },
    mixins: [ListResourceMixin, ConfirmMixin, FormResourceMixin],

    async beforeMount() {
        this.$service = new ResourceService('/api/almoxarifado-departamento')

        this.load();
    },

    methods: {
        remover(item) {
            this.$removeResource(item);
            this.load();
        },
        async selecionarAlmoxarifado(item) {
            var jaExiste = false;
            this.almoxarifados.forEach(almoxarifado => {
                if (item.id == almoxarifado.idAlmoxarifado)
                    jaExiste = true;
            });

            if (jaExiste) {
                this.$notify({
                    type: "danger",
                    message: 'Esse registro já está cadastrado',
                });
                return;
            }

            try {

                this.busy = true;
                this.fecharModalSelecionarAlmoxarifado();
                var almoxarifado = { almoxarifado: item.id, principal: 0, situacao: 1, departamento: this.departamento };
                await this.$saveResource(almoxarifado, "", false);
                this.busy = false;
                this.load();

            } catch (e) {
                this.$notify({
                    type: "danger",
                    message: e.response.data,
                });
                this.busy = false;

            }
        },
        showModalSelecionarAlmoxarifado() {
            this.modalSelecionarAlmoxarifado = true;
        },

        fecharModalSelecionarAlmoxarifado() {
            this.modalSelecionarAlmoxarifado = false;
        },
        async load() {
            this.busy = true;

            var { data } = await this.$service.get(`almoxarifados/${this.departamento.id}`);
            this.busy = false;
            this.almoxarifados = data;

        },
        async mudarFavorito(item) {
            let response = await this.$confirm(
                "Tem certeza que deseja mudar o almoxarifado principal?"
            )
            if (response == true) {
                await this.$service.put(`principal/${item.id}/${this.departamento.id}`, {});
                this.load();
            }

        },
        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Almoxarifado Departamento?",
                item.almoxarifado.toUpperCase()
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao === 1 ? 0 : 1
            }
        },


        async confirmarAlteracaoSituacao(item) {
            const { status } = await this.$service.alteraSituacao(item);
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                })
            }
        },

        cancelar() {
            this.$emit("close")
        },
    },

}
</script>